/** Width of the chart builder panel and per-dashboard AI assistant drawer (shared layout). */
export const SIDE_PANEL_WIDTH = '370px';

/** Shared inset from viewport right (px) for global AI FAB and overlay card. */
export const GLOBAL_AI_VIEWPORT_RIGHT_PX = 28;

/** Global AI assistant floating overlay card (Figma spec). */
export const GLOBAL_AI_OVERLAY_WIDTH = '340px';
/** Fixed card height (clamped to viewport so it stays above the FAB). */
export const GLOBAL_AI_OVERLAY_HEIGHT = 'min(480px, calc(100vh - 120px))';
export const GLOBAL_AI_OVERLAY_BOTTOM = '88px';
export const GLOBAL_AI_OVERLAY_RIGHT = `${GLOBAL_AI_VIEWPORT_RIGHT_PX}px`;
/**
 * Stacking tier for the global AI FAB + chat drawer. Sits ONE below the app
 * root's Chakra `portalZIndex={40}` (main.tsx), which wraps every Chakra
 * portal — modal, popover, menu, tooltip, toast — in a `z-index: 40` container
 * at `document.body`. Keeping the AI surfaces at 39 floats them above page
 * content (all well below 40 at the root) while every modal (preferences,
 * expand plot, chart actions, …) overlays the chat. The chat is a background
 * companion surface: it yields to anything opened on top of it.
 */
export const GLOBAL_AI_OVERLAY_Z_INDEX = 39;

/**
 * Build-a-dash chart config sidebar (`ChartBuilderPanel`). It's an editing
 * surface, not a modal, so it sits BELOW the global AI chat (39) and below any
 * modal (portal tier 40) while still clearing page content. The panel is
 * `<Portal>`-ed to escape the editable grid's `z-index:1 / overflow:hidden`
 * stacking context, so its stacking comes from the portal wrapper: a nested
 * `PortalManager` at this value drops that wrapper here. react-select dropdowns
 * inside keep their own 9999 menuPortal, so they stay visible.
 */
export const CHART_BUILDER_PANEL_Z_INDEX = 30;

/**
 * Z-index stamped onto Chakra portals opened from inside the global-AI chart
 * preview subtree (see `GlobalAiPortalLayer`). Must beat the drawer card
 * (`GLOBAL_AI_OVERLAY_Z_INDEX`); set to Chakra's `tooltip` theme tier so
 * these portals stack alongside app tooltips and stay below the
 * impersonation banner / product tour (9999+).
 */
export const GLOBAL_AI_PORTAL_LAYER_Z_INDEX = 1800;

/** Global AI FAB: inset from viewport right (px). */
/** @alias of GLOBAL_AI_VIEWPORT_RIGHT_PX — the FAB shares the viewport gutter. */
export const GLOBAL_AI_FAB_RIGHT_PX = GLOBAL_AI_VIEWPORT_RIGHT_PX;

/** Plot area inside each global-AI inline chart card (replots use height: 100% of this box). */
export const GLOBAL_AI_INLINE_CHART_PLOT_HEIGHT = '240px';

/**
 * Shorter plot area when a bar chart adapts to a single-value metric in the global AI chat preview
 * (avoids excess whitespace above/below the value).
 */
export const GLOBAL_AI_INLINE_CHART_METRIC_PLOT_HEIGHT = '112px';

/** Placeholder height while a global-AI inline chart is loading (slot, filters, overlay). */
export const GLOBAL_AI_INLINE_CHART_LOADING_HEIGHT = '120px';

/** Placeholder height while a compact metric bar is loading in global-AI chat. */
export const GLOBAL_AI_INLINE_CHART_METRIC_LOADING_HEIGHT = '56px';
